// extracted by mini-css-extract-plugin
export default {"container":"css_container__ekZV3","poster":"css_poster__UcsBj"};